import React from "react";

const FitDistributionBars = ({ distribution }) => {
  const total = Object.values(distribution).reduce((a, b) => a + b, 0);
  const segments = [
    { label: 'Excellent', range: '76-100', count: distribution.excellent, color: '#22c55e' },
    { label: 'Good', range: '51-75', count: distribution.good, color: '#eab308' },
    { label: 'Moderate', range: '26-50', count: distribution.moderate, color: '#f97316' },
    { label: 'Low', range: '0-25', count: distribution.poor, color: '#ef4444' },
  ];

  return (
    <div className="space-y-4">
      <div className="h-8 rounded-lg overflow-hidden flex">
        {segments.map((seg, idx) => {
          const pct = total > 0 ? (seg.count / total) * 100 : 0;
          if (pct === 0) return null;
          return (
            <div
              key={idx}
              className="h-full transition-all duration-500 first:rounded-l-lg last:rounded-r-lg"
              style={{ width: `${pct}%`, backgroundColor: seg.color }}
              title={`${seg.label}: ${seg.count} (${pct.toFixed(1)}%)`}
            />
          );
        })}
      </div>
      <div className="grid grid-cols-2 gap-3">
        {segments.map((seg, idx) => {
          const pct = total > 0 ? (seg.count / total) * 100 : 0;
          return (
            <div key={idx} className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: seg.color }} />
              <div className="flex-1 min-w-0">
                <div className="text-sm text-theme-text font-medium">{seg.label}</div>
                <div className="text-xs text-theme-text opacity-50">
                  {seg.count} creators ({pct.toFixed(0)}%)
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FitDistributionBars;
